import React,{useEffect} from "react";
import "../projectMaster/projectMaster.scss";
import "react-datepicker/dist/react-datepicker.css";
import ErrorMessage from "../../components/common/ErrorMessage";
import AddNewContactModal from "../../components/projectMaster/AddNewContactModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import AddNewCustomerModal from "../../components/common/AddNewCustomerModal";
import ProjectDetails from "../../components/projectMaster/ProjectDetails";
import FetchData from "../../providers/dataProvider";
import useForm from "./useForm";

const AddNewProject = () => {
  const {
    data: projectdata,
    loading: projectLoading,
    error: projectError,
  } = FetchData("project");
  const {
    data: customerdata,
    loading: customerLoading,
    error: customerError,
  } = FetchData("Customer");
  const {
    data: distributordata,
    loading: distributorLoading,
    error: distributorError,
  } = FetchData("distributor");
  const {
    data: projectsegment,
    loading: prjSegLoading,
    error: prjSegError,
  } = FetchData("projectsegment");
  const {
    data: projectstatus,
    loading: prjstaLoading,
    error: prjstaError,
  } = FetchData("projectstatus");
  const {
    data: countrydata,
    loading: countryLoading,
    error: countryError,
  } = FetchData("country");
  const {
    data: designationdata,
    loading: designationLoading,
    error: designationError,
  } = FetchData("designation");
  const {
    data: customertypedata,
    loading: customerTypeLoading,
    error: customerTypeError,
  } = FetchData("customertype");
  const {
    data: userprofiledata,
    loading: userprofileLoading,
    error: userprofileError,
  } = FetchData("userprofile");
  const {
    data: departmentdata,
    loading: departmentLoading,
    error: departmentError,
  } = FetchData("department");

  const {
    contractorShow,
    ContractorOpen,
    MEPlistData,
    ConAddToList,
    HandleMEPChange,
    addtoListMEP,
    addMEP,
    ConDeleteToList,
    contactShow,
    HandleContactChange,
    contacttemp,
    setContactTemp,
    HandleConDepChange,
    condepartment,
    HandleConDesChange,
    condesignation,
    HandleContactSubmit,
    setConDesignation,
    setConDepartment,
    contactError,
    deleteContact,
    setContactShow,
    EditContact,
    contact,
    formValues,
    HandleFormChange,
    HandleDropDownChange,
    prjSegment,
    prjStatus,
    prjmepCust,
    prjmainCust,
    prjDesignCust,
    prjSuperCust,
    prjClientCust,
    prjDistributorCust,
    prjCountry,
    prjStartDate,
    setprjStartDate,
    prjEndDate,
    setprjEndDate,
    formErrors,
    HandleFormSubmit,
    ClearFormValues,
    show,
    setShow,
    SuccessDoneClick,
    setprjSegment,
    setprjStatus,
    setprjmepCust,
    setprjMainCust,
    setprjDesignCust,
    setprjSuperCust,
    setprjClientCust,
    setprjDistCust,
    setprjCountry,
    prjcreateMsg,
    errorShow,
    ErrorDoneClick,
    ContactModalClose,
    defaultCustomer,
    setaddtoListMEP,
    disabledSubmit,
    customerData,
    disabledCust,
    setContractorShow,
    setListData,
    contractorValue,
    setContractorValue,
    setaddMEP,
    setFormValues,
    setContactError
  } = useForm(
    designationdata,
    customerdata,
    projectdata,
    distributordata,
    countrydata,
    userprofiledata,
    customertypedata
  );

  useEffect(()=>{
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
      if(userProfile?.userType===2)
      {
        setFormValues({
          ...formValues,
          countryId: distributordata?.find(item=>item?.id===userProfile?.userCompanyId)?.countryId,
          distributorId:userProfile?.userCompanyId
        });
      }
  },[distributordata])

        useEffect(() => {
        window.dispatchEvent(
          new CustomEvent("pathfinderHeaderMetaChange", {
            detail: {
              pathname: location.pathname,
              title: formValues?.id
                ? `Project : ${formValues?.projectName}`
                : "New Project",
              backTarget: {
                pathname: "/project-master",
              },
            },
          })
        );
      
        return () => {
          window.dispatchEvent(
            new CustomEvent("pathfinderHeaderMetaChange", {
              detail: {
                pathname: location.pathname,
                clear: true,
              },
            })
          );
        };
      }, [
        location.pathname,
        formValues?.id,
        formValues?.projectName,
      ]);

  return (
    <div className="container-fluid add-new-project-sec">
      <ProjectDetails
        customerdata={customerdata}
        distributordata={distributordata}
        projectsegment={projectsegment}
        projectstatus={projectstatus}
        countrydata={countrydata}
        ContractorOpen={ContractorOpen}
        customertypedata={customertypedata}
        MEPlistData={MEPlistData}
        ConAddToList={ConAddToList}
        HandleMEPChange={HandleMEPChange}
        addtoListMEP={addtoListMEP}
        addMEP={addMEP}
        ConDeleteToList={ConDeleteToList}
        deleteContact={deleteContact}
        setContactShow={setContactShow}
        EditContact={EditContact}
        contact={contact}
        formValues={formValues}
        HandleDropDownChange={HandleDropDownChange}
        prjSegment={prjSegment}
        prjStatus={prjStatus}
        prjmepCust={prjmepCust}
        prjmainCust={prjmainCust}
        prjDesignCust={prjDesignCust}
        prjSuperCust={prjSuperCust}
        prjClientCust={prjClientCust}
        prjDistributorCust={prjDistributorCust}
        prjCountry={prjCountry}
        prjStartDate={prjStartDate}
        setprjStartDate={setprjStartDate}
        prjEndDate={prjEndDate}
        setprjEndDate={setprjEndDate}
        formErrors={formErrors}
        HandleFormChange={HandleFormChange}
        HandleFormSubmit={HandleFormSubmit}
        ClearFormValues={ClearFormValues}
        setprjSegment={setprjSegment}
        setprjStatus={setprjStatus}
        setprjmepCust={setprjmepCust}
        setprjMainCust={setprjMainCust}
        setprjDesignCust={setprjDesignCust}
        setprjSuperCust={setprjSuperCust}
        setprjClientCust={setprjClientCust}
        setprjDistCust={setprjDistCust}
        setprjCountry={setprjCountry}
        contractorValues={contractorValue}
        setaddtoListMEP={setaddtoListMEP}
        setaddMEP={setaddMEP}
      />

      {/* <!-- addNewContactModal--> */}
      <AddNewContactModal
        setContactShow={setContactShow}
        contactShow={contactShow}
        HandleContactChange={HandleContactChange}
        contacttemp={contacttemp}
        setContactTemp={setContactTemp}
        departmentdata={departmentdata}
        designationdata={designationdata}
        HandleConDepChange={HandleConDepChange}
        condepartment={condepartment}
        HandleConDesChange={HandleConDesChange}
        condesignation={condesignation}
        HandleContactSubmit={HandleContactSubmit}
        setConDesignation={setConDesignation}
        setConDepartment={setConDepartment}
        contactError={contactError}
        ContactModalClose={ContactModalClose}
        setContactError={setContactError}
      />

      {/* <!-- deleteModal--> */}

      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />

      {/*  <!-- saveSuccessModal--> */}
      <SaveSuccessModel
        show={show}
        createMsg={prjcreateMsg}
        setShow={setShow}
        SuccessDoneClick={SuccessDoneClick}
      />
      {/* addNewContractorModal */}
      <AddNewCustomerModal
        setCustList={setListData}
        disabledDistributor={true}
        showNewCust={contractorShow}
        setShowNewCust={setContractorShow}
        customerData={customerData}
        distributorData={distributordata}
        countryData={countrydata}
        assignedEngineerData={userprofiledata}
        pageName="project"
        setNewAddedCustomer={setContractorValue}
        distributorInq={prjDistributorCust}
      />
    </div>
  );
};

export default AddNewProject;
